import { memo, useCallback } from "react";
import PropTypes from "prop-types";
import "./OperatorWidget.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { FormattedMessage } from "react-intl";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";

const OperatorWidget = ({ operatorEmail, isOperatorMode, logout }) => {
	const handleLogout = useCallback(() => {
		if (typeof logout === "function") {
			logout();
		}
	}, []);

	if (!isOperatorMode) {
		return null;
	}

	return (
		<div className="operator-widget" data-testid="operator-widget">
			<div className="operator-widget__email">
				<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR}>
					<FormattedMessage
						id="general.operator.label"
						values={{
							operatorEmail: <strong>{operatorEmail}</strong>,
						}}
					/>
				</Typography>

				<Button
					variant={BUTTON_VARIANTS.FILLED}
					size={BUTTON_SIZES.LARGE}
					onClick={handleLogout}
					label={<FormattedMessage id="menu.item.logout" />}
				/>
			</div>
		</div>
	);
};

OperatorWidget.propTypes = {
	operatorEmail: PropTypes.string,
	isOperatorMode: PropTypes.string,
	logout: PropTypes.func,
};

export default memo(OperatorWidget);
